// import { Constants } from "../ENVIROMENT_VARIABLES";

// const newPartnerContentParagraph = document.querySelectorAll("#new-partner h2+p");
// const existingCustomerContentParagraph = document.querySelectorAll("#existing-customer p");

// function replaceNbsps(str) {
//     var re = new RegExp(String.fromCharCode(10), "g");
//     return str.trim().replace(re, "<br>");
// }

// newPartnerContentParagraph.forEach( (paragraph) => {
//     paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
// });
// existingCustomerContentParagraph.forEach( (paragraph) => {
//     paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
// });

// (function () {
//     const form = document.getElementById('partner_form');

//     $(form).find('.loading-spinner').hide();
//     $(form).find('.error-message').removeClass('active');
//     $(form).find('.success-message').removeClass('active');

//     form.addEventListener('submit', function (event) {
//         $(form).find('.loading-spinner').hide();
//         $(form).find('.error-message').removeClass('active');
//         $(form).find('.success-message').removeClass('active');
//         if (!form.checkValidity()) {
//             event.preventDefault();
//             event.stopPropagation();
//         }else{
//             event.preventDefault();
//             SubmitCorporateForm(event.currentTarget);
//         }
//         $(form).addClass('was-validated');
//     }, false)

// })();


// function SubmitCorporateForm(corporateForm) {

//     var organizationInfo = JSON.stringify({
//         OrgnizationName: $(corporateForm).find('#corporate_organization').val(),
//         PhoneNumber: $(corporateForm).find('#corporate_phone').val(),
//         Email: $(corporateForm).find('#corporate_email').val()
//     });
//     $.ajax({
//         url: Constants.BASE_URL+'api/Corporate/Register',
//         method: 'POST',
//         contentType: 'application/json',
//         headers: { Authorization: 'Bearer '+ localStorage.getItem('accessToken') },
//         data: organizationInfo,
//         beforeSend: ()=>
//         {
//             $(corporateForm).find('.loading-spinner').fadeIn();
//             $('#partner-btn').attr('disabled', true);
//         },
//         success: (response) => {
//             //console.log(response);
//             $(corporateForm).find('.loading-spinner').fadeOut();
//             $('#partner-btn').attr('disabled', false);
//             $(corporateForm).find('.success-message').addClass('active');
//             setTimeout( () => {
//                 $(corporateForm).find('.success-message').removeClass('active');
//                 corporateForm.reset();
//             }, 5000);
//         },error: (err) => {
//             //console.log(err);
//             $(corporateForm).find('.loading-spinner').fadeOut();
//             $('#partner-btn').attr('disabled', false);
//             $(corporateForm).find('.error-message').addClass('active');
//             setTimeout( () => {
//                 $(corporateForm).find('.error-message').removeClass('active');
//             }, 5000);
//        }

//    }).done(()=> {
//         setTimeout( () => {
//             $(corporateForm).removeClass('was-validated');
//             corporateForm.reset();
//         }, 0);
//    });
//  } 




import 'jquery/dist/jquery.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import jquery from 'jquery';

const partner_form = $('#partner_form');
partner_form.validate({
    errorClass: "invalid",
    validClass: "valid",
    // errorElement: "em",
    rules: {
        corporate_organization: {
            required: true,
        },
        corporate_phone: {
            required: true,
            // phoneNumberFormat: true

        },
        corporate_email: {
            required: true,
            email: true
        }
    },
    onfocusout: function (element) {
        this.element(element); // triggers validation
    },
    onkeyup: function (element, event) {
        this.element(element); // triggers validation
    },
    messages: {
        corporate_organization: {
            required: "Please enter the name",
        },
        corporate_phone: {
            required: "Phone is required",
        },
        corporate_email: {
            required: "Email is required",
            email: true
        }
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
        // Add the `help-block` class to the error element
        error.addClass("alert alert-danger d-flex align-items-center mt-2");

        // Add `has-feedback` class to the parent div.form-group
        // in order to add icons to inputs
        element.parents(".input-field").addClass("is-invalid");

        if (element.prop("type") === "checkbox") {
            error.insertAfter(element.parent("label"));
        } else {
            error.insertAfter(element);
        }
    },
    success: function (label, element) {
        // //console.log('success');
        //hide error alert
        $(element).addClass("is-valid").removeClass("-invalid");
        $(element).siblings('em').removeClass("alert alert-danger d-flex align-items-center mt-2");
    },
    highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid").removeClass("is-valid");
        // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
        $(element).siblings('em').addClass("alert alert-danger d-flex align-items-center mt-2");

    },
    unhighlight: function (element, errorClass, validClass) {
        $(element).addClass("is-valid").removeClass("is-invalid");
        $(element).siblings('em').removeClass("alert alert-danger d-flex align-items-center mt-2");
    }

});
jquery.validator.addMethod("phoneNumberFormat", function (value, element) {
    return this.optional(element) || /^[(00)|(+)]{1}[0-9\\s.\\/-]{6,20}$/.test(value);
}, "Please Enter Valid Format for Phone Number");

// Add fixed country code prefix in phone number input fields
var input = document.querySelector('input[data-fixedvalue]');
input.addEventListener("keyup", function (e) {
    if (input.value.length < 5) {
        input.value = '00966';
    }
});